import React, { useRef } from 'react';

import './ContextualMenu.scss';

interface ContextualMenuProps {
  onRename: any;
  onDelete: any;
  style: any;
}

const ContextualMenu = (props: ContextualMenuProps) => {

  return (
    <ul className="contextual-menu" style={{top: props.style.top, left: props.style.left}}>
      { props.onRename &&
        <li onClick={props.onRename} className="rename">Rename</li>
      }
      { props.onDelete &&
        <li onClick={props.onDelete} className="delete">Delete</li>
      }
    </ul>
  )
}

export default ContextualMenu;